$(function () {
    function sendReq(username) {
        $.ajax({
            url: '/user/thanks',
            data: {thankTo: username},
            type: 'POST',
            dataType: 'json',
            success: function (response) {
                if(response.status === 'success'){
                    swal('', response.msg, 'success');
                    $.pjax.reload({container : '#profile-container'});
                } else {
                    swal('', response.msg, 'error');
                }
            },
            error: function () {
                swal('', 'Unknown error. Please try again later.', 'error');
            }
        });
    }

    $(document).on('click', '.action-thanks', function () {
        var username = $(this).data('username');
        if($(this).hasClass('btn-danger')){
            swal({
                title: "Are you sure?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, delete it!",
                closeOnConfirm: false
            }, function(){
                sendReq(username);
            });
        } else {
            sendReq(username);
        }
    });
});
